// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Khff","description":"PatientConsentPreview_description__JvCF6"};